import {
  RocketLaunchIcon,
  TrophyIcon,
} from '@heroicons/react/24/outline';
import AboutContentModal from './AboutContentModal';
import ContentSectionManager from './ContentSectionManager';

const initialSections = [
  { title: 'About Section', icon: RocketLaunchIcon },
  { title: 'Tournament Legacy', icon: TrophyIcon },
];

export default function HomeContentContainer() {
  return (
    <ContentSectionManager
      page="home"
      initialSections={initialSections}
      ModalComponent={AboutContentModal}
    />
  );
}
